<div class="template-editor">
  <section *ngIf="!stored" class="first">
    <p class="m-0">There's no {{ kindName }} page template yet: the website builds every {{ kindName }} page from the default one until it is created.</p>
    <button *ngIf="templates.canCreate" pButton type="button" class="p-button-sm mt-2 create-templates" icon="pi pi-plus" label="Create from defaults"
            [loading]="saving" (click)="createFromDefaults()"></button>
    <div *ngIf="!templates.canCreate" class="meta">A Developer creates it from the defaults.</div>
  </section>

  <div [hidden]="!stored">
    <section class="first">
      <div class="field">
        <label class="sub" for="tpl-name">Name</label>
        <input id="tpl-name" pInputText type="text" class="w-full" [(ngModel)]="name" />
      </div>
      <div class="field">
        <label class="sub" for="tpl-title">Title <span class="meta-inline">the browser tab and the search result's headline</span></label>
        <div class="flex gap-1">
          <input #titleInput id="tpl-title" pInputText type="text" class="w-full template-title" [(ngModel)]="title" />
          <app-placeholder-menu (pick)="addToken('title', $event, titleInput)"></app-placeholder-menu>
        </div>
      </div>
      <div class="field">
        <label class="sub" for="tpl-description">Description <span class="meta-inline">used where a page has no description or opening paragraph</span></label>
        <div class="flex gap-1">
          <textarea #descriptionInput id="tpl-description" pInputTextarea rows="2" class="w-full" [(ngModel)]="description"></textarea>
          <app-placeholder-menu (pick)="addToken('description', $event, descriptionInput)"></app-placeholder-menu>
        </div>
      </div>
      <div class="meta">Headings, links and data blocks only: each {{ kindName }}'s own text is on its Page tab, and an empty field hides its block.</div>
    </section>

    <section>
      <div class="lbl">Blocks</div>
      <app-content-sections-editor mode="template"></app-content-sections-editor>
      <button pButton type="button" class="p-button-outlined p-button-sm" icon="pi pi-plus" label="Add section" (click)="editor.addSection('section')"></button>
    </section>

    <section class="preview">
      <div class="lbl">Preview as <span class="meta-inline">the outline is the saved template; the stage shows your draft</span></div>
      <p-dropdown [options]="previewOptions" [(ngModel)]="previewId" (onChange)="preview($event.value)" [filter]="true" filterBy="label"
                  placeholder="Pick a {{ kindName }}" [showClear]="true" styleClass="w-full template-preview" appendTo="body" [baseZIndex]="12000"></p-dropdown>
      <div *ngIf="previewError" class="err text-sm mt-2">{{ previewError }}</div>
      <app-page-outline *ngIf="previewRows.length" class="mt-2" [rows]="previewRows"></app-page-outline>
      <app-block-preview-toggle class="block mt-2"></app-block-preview-toggle>
    </section>

    <div class="actions">
      <button pButton type="button" label="Cancel" class="p-button-text" [disabled]="saving" (click)="onCancel()"></button>
      <button pButton type="button" label="Save" icon="pi pi-check" class="p-button-outlined template-save" [loading]="saving" (click)="save(false)"></button>
      <button pButton type="button" label="Publish" icon="pi pi-cloud-upload" class="p-button-success template-publish" [disabled]="saving" (click)="save(true)"
              pTooltip="Save, then put every published page built from it on the website preview" tooltipPosition="top"></button>
    </div>
  </div>
</div>
